import { injectCpmsBoChargePointSubscriptionApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-charge-point-subscription.service';

import { baseApi } from '@service/base-api.service';

export const cpmsBoChargePointSubscriptionApi =
  injectCpmsBoChargePointSubscriptionApi(baseApi);

export const { useCpmsBoGetChargePointSubscriptionsQuery } =
  cpmsBoChargePointSubscriptionApi;
